import ReuseModal from "../../../../../components/fragment/modal/ReuseModal";

interface myComponentProps {
  visible: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export default function DisableMFAPrompt({
  onClose,
  visible,
  onSuccess,
}: myComponentProps) {
  const handleSubmit = () => {
    onClose();
    onSuccess();
  };

  return (
    <>
      <ReuseModal
        visible={visible}
        onClose={onClose}
        loading={false}
        onBtnClick={handleSubmit}
        btnLabel="Proceed"
        title="Disable 2FA"
      >
        <p className="delete-text">
          You are about to disable 2FA authentication. Please confirm to
          proceed.
        </p>
      </ReuseModal>
    </>
  );
}
